import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=f180c87e&scoped=true&lang=pug&"
import script from "./ComingSoon.vue?vue&type=script&lang=js&"
export * from "./ComingSoon.vue?vue&type=script&lang=js&"
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=f180c87e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f180c87e",
  null
  
)

export default component.exports